import { css, keyframes } from "vue-styled-components";

export const color = {
    primary: "#ffb73b",
    blue: "#57a5ff",
    green: "#48d497",
    pink: "#ff6795",
    red: "#ef6666",
    purple: "#9f60f2",
    hover: "#f9f9f9",
    banner_bg: "#f9fafc",
    bg: "#fafafa",
    line: "#dbdbdb",
    border: "#d7d7d7",
    disabled: "#9b9baa",
    disabled_bg: "#EBEDF6",
    black: "#5e616e",
    grad_front: "#feca3a",
    grad_middle: "#febe39",
    grad_back: "#ffa63b"
};

export const RippleAnimate = keyframes`
    100% {
        transform: translate(-50%, -50%) scale(1.7);
        opacity: 0;
    } 0% {
        transform: translate(-50%, -50%) scale(0);
        opacity: 1;
    }
`;

export const ripple = css`
    animation: ${RippleAnimate} 0.35s ease-out backwards;
`;

export const gradation = `background-image: linear-gradient(45deg, ${color.grad_front}, ${color.grad_middle}, ${color.grad_back});`;

// box disabled가 절대적이어야 한다.
export default {
    color,
    gradation,
    size: {
        header_h: "7.2rem",
        container_w: "102.4rem",
        half_container_w: "51.2rem",
        small: 4,
        middle: 4.6,
        large: 5.2
    },
    box: {
        primary: css`
            ${gradation}
            border: 1px solid transparent;
            color: #ffffff;
        `,
        primary_reverse: css`
            background-color: #ffffff;
            border: 1px solid ${color.primary};
            color: ${color.primary};
        `,
        success: css``,
        error: css``,
        warning: css``,
        black_reverse: css`
            color: ${color.black};
            background-color: #ffffff;
            border: 1px solid ${color.black};
        `,
        disabled: css`
            background-image: none;
            background-color: ${color.disabled_bg} !important;
            border: 1px solid ${color.disabled_bg} !important;
            color: ${color.disabled} !important;
        `,
        ghost: css`
            background-color: transparent;
            border: 2px solid #ffffff;
            color: #ffffff;
        `,
        readonly: css`
            background-color: #ffffff;
            border: 1px solid ${color.primary};
        `
    }
};
